export default __webpack_public_path__ + "static/media/white.cdd6382c.png";